import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from "body-scroll-lock";

class MenuMobile {
  constructor(windowSizes) {
    this.duration = 1.5;
    this.windowSizes = windowSizes;

    this.container = document.querySelector(".header__nav");
    this.button = document.querySelector(".header__nav__button");
    this.cross = this.button.querySelector(".header__nav__button__cross");
    this.menu = this.container.querySelector(".header__nav__menu");

    this.menuFirstLevel = this.container.querySelectorAll(".first-level");
    this.menuOpened = false;
    this.init();
  }

  init() {
    this.initEvents();
  }

  initEvents() {
    this.button.addEventListener("click", () => {
      this.onButtonClick();
    });
    Array.from(this.menuFirstLevel, (m, index) => {
      const links = m.getElementsByTagName("a");
      if (links[0]) {
        links[0].addEventListener("click", () => {
          links[0].isOpen = false;
          this.onLiClick(m);
        });
      }
    });
  }

  onLiClick(li) {
    const isOpen = li.isOpen;
    this.closeAllMenus();
    const ul = li.querySelector(".sub-menu");
    if (ul) {
      if (isOpen) {
        ul.classList.remove("sub-menu--active");
        li.isOpen = false;
      } else {
        ul.classList.add("sub-menu--active");
        li.isOpen = true;
      }
    }
  }

  disableScroll() {
    // 3. Disable body scroll
    disableBodyScroll(this.menu);
  }
  enableScroll() {
    enableBodyScroll(this.menu);
  }
  onButtonClick() {
    this.menuOpened = !this.menuOpened;

    if (this.menuOpened) {
      this.disableScroll();
      this.menu.classList.add("header__nav__menu--open");
      this.button.classList.add("header__nav__button--open");
    } else {
      this.enableScroll();
      this.menu.classList.remove("header__nav__menu--open");
      this.button.classList.remove("header__nav__button--open");
    }
  }

  closeAllMenus() {
    Array.from(this.menuFirstLevel, (m, index) => {
      const menu = m.querySelector(".sub-menu");
      m.isOpen = false;

      if (menu) {
        menu.classList.remove("sub-menu--active");
      }
    });
  }

  /** Resize Event */
  resize(windowSizes) {
    this.windowSizes = windowSizes;
    if (this.container) {
      this.setSizes();
    }
  }
}

export default MenuMobile;



// WEBPACK FOOTER //
// ./src/js/components/MenuMobile.js